import { createFiltersActions } from '../utils';

export const ACTIONS_PREFIX = 'VIRTUAL_MACHINES';

export const {
    updateFilters,
    applyFilters,
    resetApplyFilters,
    resetApplyFiltersSilently,
    rebuildApplyFiltersSilently
} = createFiltersActions(ACTIONS_PREFIX);
